module.exports = __webpack_public_path__ + "static/media/adminbg.38ada0a3.png";